import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AccountTypeEnum } from "@/lib/constants";
import useAccountCommonColumns from "@/module/accounts-module/hooks/account-common-columns-hook";
import { SysAccountRegularDto } from "@/shared/api";
import { AnyObj, MRT_OrderedColumnDef, NilObj } from "@/types/common-types";

export const useServiceAccountsTableColumns = ({ room }: { room: string }) => {
  const { t } = useTranslation();
  const commonColumns = useAccountCommonColumns({ room });

  return useMemo<MRT_OrderedColumnDef<SysAccountRegularDto>[]>(
    () => [
      {
        id: "data.account_type",
        header: t("serviceAccountsTable.accountType"),
        order: 301,
        accessorFn: ({ data }) => {
          const accountType = (data as AnyObj)?.account_type;

          if (typeof accountType !== "number") return "-";
          return `${accountType} (${AccountTypeEnum[accountType]})`;
        },
      },
      ...commonColumns,
    ],
    [t, commonColumns]
  );
};
